import { render, staticRenderFns } from "./kapor-form-error.vue?vue&type=template&id=7c489180&lang=pug"
import script from "./kapor-form-error.vue?vue&type=script&lang=js"
export * from "./kapor-form-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports